import api from './api'

export default {
  async login(credentials) {
    const { data } = await api.post('/admin/login', credentials)
    return data
  },
  
  async logout() {
    try {
      await api.post('/admin/logout')
    } catch (error) {
      console.error('Logout error:', error)
    }
  },
  
  async checkAuth() {
    try {
      const { data } = await api.get('/admin/me')
      return data
    } catch (error) {
      console.error('Check auth error:', error)
      throw error
    }
  },
  
  async changePassword(passwordData) {
    try {
      const { data } = await api.post('/admin/update-password', passwordData)
      return data
    } catch (error) {
      console.error('Change password error:', error)
      throw error
    }
  }
} 